import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AssessmentRef } from "./AssessmentRef";
import type { AssessmentStaff } from "./AssessmentStaff";
import type { PersonSkillDTOBase } from "./PersonSkillDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { SkillRef } from "./SkillRef";
import type { SkillStaff } from "./SkillStaff";
import type { TrackedBase } from "./TrackedBase";

export class PersonSkillStaff implements PersonSkillDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly assignId: number, public readonly skillId: SkillStaff | null, public readonly assessmentId: AssessmentStaff | null, public readonly dateChanged: Date | null, public readonly instructor: string | null, public readonly comments: string | null, public readonly active: boolean, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly personId: PersonStaff | null, public readonly skillIdTargetIds: SkillRef, public readonly assessmentIdTargetIds: AssessmentRef, public readonly skillName: string | null, public readonly assessmentName: string | null, public readonly assessmentSeq: number | null) {
    this.cbiServiceContext = null;
    this.skillIdLoaded = this.skillId != null;
    this.skillIdCached = this.skillId;
    this.assessmentIdLoaded = this.assessmentId != null;
    this.assessmentIdCached = this.assessmentId;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private skillIdLoaded: boolean;
  private skillIdCached: SkillStaff | null;
  private assessmentIdLoaded: boolean;
  private assessmentIdCached: AssessmentStaff | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async skillIdLazy(): Promise<SkillStaff> {
    if (!this.skillIdLoaded) {
      this.skillIdCached = await this.cbiServiceContext!.personService().getSkillStaff(this.skillIdTargetIds.skillId);
      this.skillIdLoaded = true;
    }
    return this.skillIdCached!;
  }
  async assessmentIdLazy(): Promise<AssessmentStaff> {
    if (!this.assessmentIdLoaded) {
      this.assessmentIdCached = await this.cbiServiceContext!.personService().getAssessmentStaff(this.assessmentIdTargetIds.assessmentId);
      this.assessmentIdLoaded = true;
    }
    return this.assessmentIdCached!;
  }
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonSkillStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
